import React from 'react';
import {
  IDealerTicket,
  IDealerTicketsBatchArchive,
} from 'thunks/RTKQuery/dealer';
import { Table } from 'components/Table';
import {
  TableChangeType,
  SortOrder,
  SelectRowProps,
} from 'react-bootstrap-table-next';
// import { Link } from 'react-router-dom';
// import { DeleteIcon } from 'icons';
import { Row, Col, Button } from 'react-bootstrap';
import i18n from 'translations';
import { getColumns } from './columns';

export interface ISortBy {
  order: SortOrder;
  dataField: string;
}

interface IDealerTicketsResponseComponent {
  tickets: IDealerTicket[];
  count: number;
  page: number;
  sizePerPage: number;
  setPage: (page: number) => void;
  setSortBy: (sortBy: ISortBy) => void;
  sortBy: ISortBy;
  openCustomerDialog: (row: IDealerTicket) => void;
  openDealerDialog: (row: IDealerTicket) => void;
  openFMCustomerDialog: (row: IDealerTicket) => void;
  handleDelete: (ticket: IDealerTicket) => void;
  handleBatchArchive: (archivedTickets: IDealerTicketsBatchArchive) => void;
  archiveStatus: boolean | undefined;
  showFMCustomer: boolean;
}

export const DealerTicketsComponent: React.FC<IDealerTicketsResponseComponent> = ({
  tickets,
  count,
  setPage,
  setSortBy,
  page,
  sizePerPage,
  sortBy,
  openCustomerDialog,
  openDealerDialog,
  openFMCustomerDialog,
  handleDelete,
  handleBatchArchive,
  archiveStatus,
  showFMCustomer,
}: IDealerTicketsResponseComponent) => {
  const [selectedRows, setSelectedRows] = React.useState<IDealerTicket[]>([]);
  const columns = getColumns(
    openCustomerDialog,
    {
      parentDealerId: true,
      isWibuUpdateAvailable: true,
      licenseKey: true,
    },
    openDealerDialog,
    openFMCustomerDialog,
    handleDelete,
    showFMCustomer
  );

  // clear selection on change of archive Status
  React.useEffect(() => {
    setSelectedRows([]);
  }, [archiveStatus]);

  const handleOnSelect = (row: IDealerTicket) => {
    // No action on single select
    const isSelected = selectedRows.find(
      (r) => r.dealerTicketId === row.dealerTicketId
    );
    if (isSelected) {
      setSelectedRows(
        selectedRows.filter((r) => r.dealerTicketId !== row.dealerTicketId)
      );
    } else {
      setSelectedRows([...selectedRows, row]);
    }
  };

  const selectRow: SelectRowProps<IDealerTicket> = {
    mode: 'checkbox',
    clickToSelect: false,
    hideSelectColumn: false,
    selected: selectedRows.map((r) => r.ticketId),
    onSelect: (row: IDealerTicket) => {
      handleOnSelect(row);
    },
    onSelectAll: (isSelect, rows: IDealerTicket[]) => {
      if (isSelect) {
        setSelectedRows(rows);
      } else {
        setSelectedRows([]);
      }
    },
  };

  return (
    <>
      {selectedRows.length > 0 && archiveStatus !== undefined && (
        <Row className="mb-2 grey ml-0 mr-0">
          <Col md={12}>
            <strong>
              {i18n.t('dealerManagement.tickets.rowsSelected', {
                rowsCount: selectedRows.length,
              })}
              {' - '}
            </strong>
            <Button
              size="sm"
              variant="outline-primary"
              onClick={() => {
                handleBatchArchive({
                  dealerTicketIds: selectedRows.map((r) => r.dealerTicketId),
                  isArchived: !archiveStatus,
                });
                setSelectedRows([]);
              }}
            >
              {archiveStatus
                ? i18n.t('dealerManagement.tickets.unarchiveSelected')
                : i18n.t('dealerManagement.tickets.archiveSelected')}
            </Button>
          </Col>
        </Row>
      )}
      <Table
        key={`table-${tickets.length}`}
        data={tickets}
        keyField="ticketId"
        columns={columns}
        page={page}
        sizePerPage={sizePerPage}
        totalSize={count}
        defaultSorted={[sortBy]}
        wrapperClasses="table-dealer-ticket-content"
        onTableChange={(type: TableChangeType, state) => {
          if (type === 'pagination') {
            setPage(state.page);
            setSelectedRows([]);
          }
          if (type === 'sort') {
            if (
              state.sortField !== sortBy.dataField ||
              state.sortOrder !== sortBy.order
            ) {
              setSortBy({
                dataField: state.sortField,
                order: state.sortOrder,
              });
            }
            setSelectedRows([]);
          }
        }}
        selectRow={selectRow}
      />
    </>
  );
};

DealerTicketsComponent.defaultProps = {};
